import { useMutation } from 'react-query';
import { convertTemplate } from '../utils/queries';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useTemplateEditorDispatch, useTemplateEditorState } from '../context/UseTemplateEditorContext';
import useNotifications from 'core/notifications/useNotifications';

export const useConvertTemplate = () => {
  const { t } = useTranslation(['designs', 'trackingLinks']);
  const { siteId } = useParams<{ siteId: string }>();
  const { showNotification } = useNotifications();

  const { template } = useTemplateEditorState();
  const dispatch = useTemplateEditorDispatch();

  const { mutate } = useMutation(convertTemplate);

  return useCallback(() => {
    mutate(
      {
        payload: {
          siteId: siteId,
          template: template?.template ?? '',
        },
        t,
      },
      {
        onSuccess: data => {
          dispatch({
            type: 'UPDATE_TEMPLATE',
            payload: {
              precompiledTemplate: data.convertedTemplate,
            },
          });
        },
        onError: (error: Error) => {
          showNotification(error.message, 'error');
        },
      },
    );
  }, [dispatch, mutate, showNotification, siteId, t, template?.template]);
};
